// @flow
import React, { type Element, memo, type ComponentType } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { TableBody, TableCell, TableRow, Box, Tooltip } from '@material-ui/core';
import { CheckCircleOutline } from '@material-ui/icons';
import { useApp } from 'helpers';
import { useLocation } from 'hooks';
import { ButtonSecondary } from './ComponentTypes';
import Table from '../types/Table';
import Container from '../types/Containers';

type DashboardBestPracticesTypes = {
  record: Object
};

const TableBodyCell: ComponentType<*> = styled(TableCell)`
  && {
    font-size: var(--fontSize);
    border-bottom: none;
    padding: calc(var(--spacing) / 2) calc(var(--spacing) * 2);
    &:nth-child(1) {
      padding-left: 0;
    }
    &:nth-last-child(1) {
      padding-right: 0;
    }
  }
`;

const CheckCircleOutlineIcon: ComponentType<*> = styled(CheckCircleOutline)`
  color: var(--colorSystemSuccess);
  font-size: 24px;
`;

const DashboardBestPractices = ({ record }: DashboardBestPracticesTypes): Element<*> => {
  const history = useHistory();
  const { dispatch } = useApp();
  const { app: appLoc } = useLocation();
  const disableAction = appLoc === 'clients';

  const actionClick = link => {
    const [app, tabLink] = link.split('/');
    const tab = tabLink.split('?')[0];
    const activeTabType = tabLink.split('?')[1] || '';
    history.push(`/${app}/${tab}`);
    dispatch.changeTab(app, tab, 'complianceDashboard', null, false, activeTabType);
  };

  return (
    <Container.Paper>
      <Table.Container size="small" mt={1} radius={2}>
        <TableBody>
          {record.map(row => (
            <TableRow key={row.id}>
              <TableBodyCell>{row.action}</TableBodyCell>
              <TableBodyCell align="center" style={{ width: 36 }}>
                {row.completed ? (
                  <Box display="flex" alignItems="center" justifyContent="center" height={34}>
                    <CheckCircleOutlineIcon />
                  </Box>
                ) : disableAction || row.disabled ? (
                  <Tooltip title={disableAction ? '' : 'Feature not Available'} placement="left" arrow>
                    <div>
                      <ButtonSecondary disabled>Go</ButtonSecondary>
                    </div>
                  </Tooltip>
                ) : (
                  <ButtonSecondary
                    onClick={e => {
                      e.preventDefault();
                      actionClick(row.link);
                    }}
                  >
                    Go
                  </ButtonSecondary>
                )}
              </TableBodyCell>
            </TableRow>
          ))}
        </TableBody>
      </Table.Container>
    </Container.Paper>
  );
};
export default memo<DashboardBestPracticesTypes>(DashboardBestPractices);
